import { useState, useContext } from "react"
import { motion } from "framer-motion"
import TopoMenu from "../../../componentes/gerais/TopoMenu"
import MenuLateral from "../../../componentes/gerais/Menu"
import { configAnim } from "../../../servicos/config/configAnim"
import { Card, Collapse } from "@mui/material"
import { MdExpandMore, MdKeyboardArrowRight, MdLightbulb } from "react-icons/md"
import { ContextoGeral } from "../../../contextos/ContextoGeral"

export default function CentralAjuda() {
	const [menu, setMenu] = useState(false)
	const [expanded, setExpanded] = useState(0)
	const { centralAjuda } = useContext(ContextoGeral)
	const faqs = centralAjuda?.dados?.topicos || []
 
	const handleExpand = (index) => {
		setExpanded(expanded === index ? null : index)
	}

	return (
		<motion.div
			style={{ height: '100%', backgroundColor: '#f5f5f5', minHeight: 'calc(var(--app-vh) - 3rem)' }}
			initial={configAnim.initial}
			animate={configAnim.animate}
			exit={configAnim.exit}
			transition={configAnim.transition}
		>
			<TopoMenu voltar="/app/home" titulo="CENTRAL DE AJUDA" setShow={setMenu} />
			<div style={{ padding: '1rem' }}>
				<Card sx={{ 
					borderRadius: '12px', 
					backgroundColor: 'white',
					padding: '1.5rem',
					boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
					overflow: 'hidden',
					width: '100%',
					boxSizing: 'border-box'
				}}>
					{/* Header */}
					<div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: '1.5rem' }}>
						<MdLightbulb 
							size={28} 
							style={{ 
								color: '#FFC107', 
								marginRight: '0.75rem',
								marginTop: '2px',
								flexShrink: 0
							}} 
						/>
						<div>
							<h2 style={{ 
								margin: 0, 
								fontSize: '1.5rem', 
								fontWeight: 'bold',
								color: '#212121',
								marginBottom: '0.5rem'
							}}>
								Central de ajuda
							</h2>
							<p style={{ 
								margin: 0, 
								fontSize: '0.875rem', 
								color: '#757575'
							}}>
								Dúvidas rápidas sobre esta tela.
							</p>
						</div>
					</div>

					{/* FAQ Items */}
					<div>
						{faqs.map((faq, index) => (
							<div 
								key={index}
								style={{
									position: 'relative',
									border: expanded === index ? '1px solid #6366f1' : 'none',
									background: expanded === index ? '#ffffff' : undefined,
									transform: expanded === index ? 'translateY(-2px)' : undefined,
									boxShadow: expanded === index ? '0 14px 32px rgba(99, 102, 241, 0.25)' : undefined,
									transition: 'all 0.3s ease',
									borderRadius: expanded === index ? '12px' : '0',
									margin: expanded === index ? '0.5rem 0' : '0'
								}}
							>
								{expanded === index && (
									<div style={{
										position: 'absolute',
										left: '0',
										top: '0',
										bottom: '0',
										width: '4px',
										background: 'linear-gradient(to bottom, #6366f1, #a855f7)',
										borderRadius: '2px'
									}} />
								)}
								<div
									onClick={() => handleExpand(index)}
									style={{
										display: 'flex',
										alignItems: 'center',
										padding: '1rem',
										cursor: 'pointer',
										paddingLeft: expanded === index ? '1.5rem' : '1rem',
										transition: 'padding-left 0.2s'
									}}
								>
									{/* Número em círculo roxo */}
									<div style={{
										width: '32px',
										height: '32px',
										borderRadius: '50%',
										background: 'linear-gradient(135deg, #e0e7ff, #4f46e5)',
										color: 'black',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										fontWeight: 'bold',
										fontSize: '0.875rem',
										marginRight: '1rem',
										flexShrink: 0
									}}>
										{index + 1}
									</div>
									{/* Pergunta */}
									<div style={{ flex: 1, fontSize: '0.9375rem', color: '#212121' }}>
										{faq.titulo}
									</div>
									{/* Ícone de seta */}
									<div style={{ marginLeft: '0.5rem', flexShrink: 0 }}>
										{expanded === index ? (
											<MdExpandMore size={24} style={{ color: '#757575' }} />
										) : (
											<MdKeyboardArrowRight size={24} style={{ color: '#757575' }} />
										)}
									</div>
								</div>
								{/* Resposta */}
								<Collapse in={expanded === index}>
									<div style={{
										padding: '0 1rem 1rem 1.5rem',
										fontSize: '0.875rem',
										color: '#616161',
										lineHeight: '1.5',
										wordBreak: 'break-word',
										overflowWrap: 'break-word',
										whiteSpace: 'pre-wrap',
										maxWidth: '100%',
										boxSizing: 'border-box'
									}}>
										{faq.texto}
									</div>
								</Collapse>
							</div>
						))}
					</div>
				</Card>
			</div>
			<MenuLateral show={menu} setShow={setMenu} />
		</motion.div>
	)
}

